import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "./auth.guard";
import { UIComponent } from "./ui/ui.component";
import { LoginComponent } from "./login/login.component";
import { NewUserEmailComponent } from "./new-user-email/new-user-email.component";

export const routes: Routes = [
  {
    path: "mdmgr",
    loadChildren: () =>
      import("./mdmgr/mdmgr.module").then((m) => m.AppMdMgrModule),
    canActivate: [AuthGuard],
  },
  { path: "", component: UIComponent, canActivate: [AuthGuard] }, // Fixed authGuard -> AuthGuard
  { path: "login", component: LoginComponent },
  { path: "signup", component: NewUserEmailComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)], // Fixed 'i mports' -> 'imports'
  exports: [RouterModule],
})
export class AppRoutingModule {}